module.exports = __webpack_public_path__ + "static/media/postcard-fr.af02858c.png";